import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function FeaturedSection() {
  const featured = videos.filter((v) => v.rating >= 9.0).slice(0, 8);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">
              精选高分日韩影视内容，品质保证
            </p>
          </div>
          <Link
            to="/category"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {featured.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group cursor-pointer"
            >
              <div className="relative rounded-lg overflow-hidden aspect-video mb-3">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-bold px-2 py-1 rounded">
                  {video.rating}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-4xl text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                {video.title}
              </h3>
              <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                <span>{video.region}</span>
                <span>·</span>
                <span>{video.year}</span>
                <span>·</span>
                <span>{video.views}次播放</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}